import { observer } from 'mobx-react';

import styles from './OrganizationDataPage.module.scss';

import { store } from '@store';
import { VirtualTable } from '@components/Table';
import { MobileCardList } from '@components/MobileCardList';

import { useOrganizationDataPage } from './hooks/useOrganizationDataPage';

export const OrganizationDataPage = observer(() => {
    const { viewPort } = store;
    const { data, columns, mobileFields, onRow, onMobileCardClick } = useOrganizationDataPage();

    return (
        <div className={styles.root}>
            {data.map(item => (
                <div
                    className={styles.table}
                    key={item.legalEntityId}
                >
                    {viewPort.isMobileSize ? (
                        <MobileCardList
                            data={item.organizations}
                            fields={mobileFields}
                            onCardClick={onMobileCardClick}
                        />
                    ) : (
                        <VirtualTable
                            tableTitle={item.name}
                            rowKey={'id'}
                            minHeight={63}
                            columns={columns}
                            dataSource={item.organizations}
                            count={item.organizations.length}
                            onRow={onRow}
                        />
                    )}
                </div>
            ))}
        </div>
    );
});
